import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { getEffectiveDatesOptions } from 'global/services-helpers/domainService';
import { makeAutoObservable } from 'mobx';
import { getRootStoreInstance, RootStore } from 'store/rootStore';

type AltusQuoteProposalInfoFields = {
  proposalName: FormControl<string>;
  effectiveDate: FormControl<string>;
  zip: FormControl<string>;
  state: FormControl<string>;
  county: FormControl<string>;
};

export class AltusQuoteProposalInfoFormDelegate {
  private readonly _rootStore: RootStore = getRootStoreInstance();
  public proposalForm: FormController<AltusQuoteProposalInfoFields>;

  public get effectiveDatesOptions(): OptionType[] {
    return getEffectiveDatesOptions(this._rootStore.domainStoreV2.effectiveDates);
  }

  constructor() {
    this.proposalForm = FormController.create(
      {
        proposalName: new FormControl<string>('', {
          validations: ['printableCharacters'],
        }),
        effectiveDate: new FormControl<string>(''),
      },
      {
        capabilities: [
          {
            type: 'zip',
            params: {
              state: {
                customValidations: [
                  {
                    check: this._rootStore.domainStoreV2.isEligibleState,
                    msg: 'State is ineligible',
                  },
                ],
              },
            },
          },
        ],
      },
    );

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
